<div id="scroll-to-top-ref" class="subscribe-bar">
  <div class="klaviyo-form-ViPYDt"></div>
</div>

<section class="section-hero animated fadeInUp">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="title is-left px-4 px-md-0">
          <h1 class="title__main">Fresh, locally grown foods — delivered to your door</h1>
          <p class="title__sub">When you shop our online market, you're getting the best food our region has to offer.
            Plus, you're also supporting producers in our community and strengthening the local food system</p>
        </div>
        <div class="spacer"></div>
        <div class="d-flex justify-content-center justify-content-md-start gap-3">
          <a class="btn btn-secondary" routerLink='/signup'>Create a free account</a>
          <a class="btn btn-primary" routerLink='/login'>Log in</a>
        </div>

      </div>
      <div class="col-md-5 offset-md-1">
        <!--<img src="../../../assets/images/landing/home/hero-product.webp" class="img-fluid"/>-->
      </div>
    </div>
  </div>
</section>

<section class="section-membership">
  <div class="container">
    <div class="title is-center is-full-width">
      <h2 class="title__main mb-5">What's included in your free account</h2>
    </div>
    <div class="row align-items-center">
      <div class="col-md-6 has-animation fadeInLeft">
        <div class="about-img" style="background-image: url('assets/images/landing/home/spread.webp')"
          title="PFW Membership">
          <!--          <img src="assets/images/logo-white.svg" class="about-img__logo" alt="PFW Membership">-->
        </div>
      </div>
      <div class="col-md-6 has-animation fadeInRight">
        <ul class="ul-checklist is-col-2 is-row-gap-lg">
          <li>Access to the largest selection of local products in the region</li>
          <li>Recyclable, minimal-waste, and returnable packaging</li>
          <li>Hard-to-find varieties of seasonal fruits and veggies</li>
          <li>Low minimum order and home delivery fees</li>
          <li>Personalized customer service</li>
          <li>Community food tasting and meet-the-maker events</li>
        </ul>
        <div class="d-flex justify-content-center">
          <a class="btn btn-primary" routerLink='/signup'>Create your account to start shopping</a>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="section-how">
  <div class="container">
    <div class="title is-center">
      <h2 class="title__main">How it Works</h2>
    </div>
    <div class="row has-animation fadeInUp">
      <div class="col-md-4">
        <div class="how-step">
          <span class="icon material-symbols-outlined">share_location</span>
          <div class="detail">
            <div class="num">1</div>
            <div class="text">Enter your delivery address</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="how-step">
          <span class="icon material-symbols-outlined">person_edit</span>
          <div class="detail">
            <div class="num">2</div>
            <div class="text">Pick your delivery window and create your FREE account</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="how-step has-no-dash">
          <span class="icon material-symbols-outlined">add_shopping_cart</span>
          <div class="detail">
            <div class="num">3</div>
            <div class="text">Select recurring food shares and customize/shop when the market opens</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 d-flex justify-content-center">
      <a class="btn btn-secondary" routerLink='/signup'>Create your free membership</a>
    </div>
  </div>
</section>


<section class="section-apart">
  <div class="container">
    <div class="title is-center is-full-width">
      <h2 class="title__main">Why You Can Trust Shopping With Us</h2>
      <h4 class="title__sub mb-5">Our deep commitment to building a local food system</h4>
    </div>
    <div class="row  row-eq-height align-items-center">
      <div class="col-xl-7 has-animation fadeInLeft">
        <ul class="ul-checklist is-col-2 is-row-gap-lg">
          <li>We've been serving the Philadelphia area since 2014.</li>
          <li>All food that is not sold or donated is composted at one of our partner farms.</li>
          <li>We use zero waste packaging materials like returnable boxes, cold packs/liners and clam shells.</li>
          <li>We average 1.1 miles driven per delivery and use 100% renewable energy in our warehouse.</li>
          <li>We invest financially in the farms we work with, commit to pre-season crop planning, and coordinate
            trucking logistics.</li>
          <li>Our farmers prioritize flavor, growing the tastiest varieties and picking produce at peak ripeness. </li>
          <li>We collaborate with 8 different community organizations to deliver food to people in need.</li>
          <li>We’ve established a network of over 200 producers to provide a wide variety of local products.</li>
        </ul>
      </div>
      <div class="col-xl-5 has-animation fadeInRight">
        <img src="assets/images/landing/home/what-set-us-apart.webp"
          class="img-fluid is-ratio-3-2 is-lg-ratio-2-3 is-md-ratio-3-2" alt="Why You Can Trust Shopping With Us" />
      </div>
    </div>
  </div>
</section>


<section class="section-testimonials has-animation fadeInUp">
  <div class="container">
    <div class="title is-center is-full-width">
      <h2 class="title__main">Why our customers love us</h2>
      <p class="title__sub">We are building a food system together</p>
    </div>
    <div class="testimonials">
      @for (item of testimonials; track item) {
      <div class="testimonial">
        <div class="rating">
          <ul class="rating-star">
            <li *ngFor="let star of [].constructor(item.star); let i = index"><i class="fa-solid fa-star"></i></li>
          </ul>
        </div>
        <div class="detail">
          <div class="text">{{item.quote}}</div>
          <div class="name">{{ item.name }}</div>
          @if (item.subTitle != ''){
          <div class="meta">{{item.subTitle}}</div>
          }
        </div>
      </div>
      }
    </div>
    <div class="d-flex justify-content-center">
      <a class="btn btn-primary" routerLink='/signup'>Sign up now</a>
    </div>
  </div>
</section>

<section class="has-padding-block-5">
  <div class="container-fluid">
    <div class="title is-center is-full-width">
      <h2 class="title__main mb-5">Want to learn more?</h2>
    </div>
    <div class="flash-card-wrap has-animation fadeInUp">
      <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-1.webp')">
        <div>
          <div class="flash-card__title">Learn more about ordering and delivery</div>
          <a class="btn btn-secondary" routerLink='/pages/how-it-works/main'>How it works</a>
        </div>
      </div>
      <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-2.webp')">
        <div>
          <div class="flash-card__title">Explore the amazing, local products in our market</div>
          <a class="btn btn-primary" routerLink='/shop'>Our products</a>
        </div>
      </div>
      <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-3.webp')">
        <div>
          <div class="flash-card__title">Meet our network of 200+ farmers and producers</div>
          <a class="btn btn-secondary" routerLink='/pages/producers'>Our producers</a>
        </div>
      </div>
      <div class="flash-card" style="background-image: url('assets/images/landing/flash-card/img-4.webp')">
        <div>
          <div class="flash-card__title">Learn how we are building an equitable food system</div>
          <a class="btn btn-primary" routerLink='/pages/about-us/main'>How we help</a>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
